// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C04 agreements register. Keep every rule inside the content workspace. */
.rcti-agreements.rcti-designed
  .rcti-agreements__content.rcti-c04-register-page {
  padding: var(--space-8);
  gap: var(--space-6);
}
.rcti-agreements .rcti-c04-register-page .rcti-design-breadcrumb {
  display: none;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-heading {
  margin-bottom: var(--space-1);
}
.rcti-agreements .rcti-c04-register-page .rcti-design-metrics {
  gap: var(--space-6);
}
.rcti-agreements
  .rcti-c04-register-page
  .rcti-design-metrics
  > button.rcti-agreement-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-content: start;
  justify-items: start;
  height: auto;
  min-height: 154px;
  width: 100%;
  gap: 0;
  padding: var(--space-6);
  text-align: left;
  box-shadow: none;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-metrics > button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-metrics > button > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  color: var(--text-primary);
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
  line-height: 1.4;
  width: 100%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-metrics svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: var(--interactive-default);
}
.rcti-agreements .rcti-c04-register-page .rcti-design-metrics strong {
  display: block;
  margin-top: var(--space-6);
  font-family: var(--font-family-mono);
  font-size: var(--font-size-money-lg);
  font-weight: var(--font-weight-medium);
  line-height: 1.2;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-metrics small {
  display: block;
  margin-top: var(--space-2);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-regular);
  line-height: 1.4;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-tabs {
  margin-bottom: calc(-1 * var(--space-3));
}
.rcti-agreements .rcti-c04-register-page .document-status-tabs > button:not(.is-active):not(:disabled) {
  color: var(--text-primary);
}
.rcti-agreements .rcti-c04-register-page .document-status-tabs > button:not(.is-active):not(:disabled):hover {
  color: var(--text-secondary);
  background: transparent;
  box-shadow: none;
  filter: none;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-filter {
  gap: var(--space-3);
}
.rcti-agreements .rcti-c04-register-page .rcti-design-filter .rcti-c04-search {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex: 0 1 420px;
  width: 420px;
  height: 40px;
  padding: 0 var(--space-3);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
}
.rcti-agreements .rcti-c04-register-page .rcti-c04-search > svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  color: var(--text-secondary);
}
.rcti-agreements
  .rcti-agreements
  .rcti-c04-register-page
  .rcti-c04-search
  input {
  padding: 0;
  min-height: 0;
  height: 38px;
  border: 0;
  background: transparent;
  border-radius: 0;
  font: inherit;
  box-shadow: none;
}
.rcti-agreements
  .rcti-c04-register-page
  .rcti-design-filter
  > .quotation-figma-dropdown {
  flex: 0 0 160px;
  min-width: 0;
  width: 160px;
}
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-trigger {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  border-width: 1px;
  padding-inline: 12px;
  border-radius: var(--radius-md, 10px);
  border-color: var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: 500 13px var(--font-family-primary);
}
.rcti-agreements .rcti-c04-register-page .rcti-c04-clear-filters {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
  background: var(--surface-primary);
  color: var(--text-primary);
  font: 500 13px var(--font-family-primary);
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.rcti-agreements .rcti-c04-register-page .rcti-c04-clear-filters:hover {
  background: var(--surface-secondary);
  border-color: var(--border-default);
  filter: none;
}
.rcti-agreements .rcti-c04-register-page .rcti-c04-clear-filters:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu {
  z-index: 1300 !important;
  max-height: 240px;
  overflow-y: auto;
  border-color: var(--border-default);
  background: var(--surface-primary);
}
/* Menus portal into the register content, outside the filter toolbar. */
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu .quotation-figma-dropdown-option {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  height: auto;
  min-height: 36px;
  padding: 8px 10px;
  font: 400 13px/20px var(--font-family-primary);
  text-align: left;
  white-space: normal;
}
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu .quotation-figma-dropdown-option > span {
  flex: 1 1;
  min-width: 0;
  overflow-wrap: anywhere;
}
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu .quotation-figma-dropdown-option:is(:hover, :focus-visible, .is-selected):not(:disabled) {
  background: var(--interactive-soft);
  color: var(--interactive-default);
  filter: none;
}
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-trigger:hover {
  border-color: var(--border-strong);
}
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger,
.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-trigger:focus-visible {
  border: 1px solid var(--interactive-default);
  padding-inline: 12px;
  box-shadow: none;
}
.rcti-c04-table-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-4);
  min-height: 52px;
  font-size: var(--font-size-body-sm);
}
.rcti-c04-table-heading h2 {
  font-size: var(--font-size-body-md);
}
.rcti-c04-table-heading span {
  color: var(--text-secondary);
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register table {
  min-width: 1040px;
  table-layout: fixed;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register th,
.rcti-agreements .rcti-c04-register-page .rcti-design-register td {
  padding: 12px;
  vertical-align: middle;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register th {
  height: 44px;
  font-size: var(--font-size-caption-md);
  white-space: nowrap;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register td {
  font-size: var(--font-size-body-sm);
  height: 68px;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(1) {
  width: 19%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(2) {
  width: 21%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(3) {
  width: 8%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(4) {
  width: 12%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(5) {
  width: 12%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(6) {
  width: 20%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(7) {
  width: 8%;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(2) {
  overflow-wrap: anywhere;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(3),
.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(4),
.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(5) {
  white-space: nowrap;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(6) small {
  margin-top: 3px;
  line-height: 1.35;
}
.rcti-agreements .rcti-c04-register-page .rcti-design-register th:last-child,
.rcti-agreements .rcti-c04-register-page .rcti-design-register td:last-child {
  text-align: right;
  white-space: nowrap;
}
.rcti-agreement-register-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.rcti-agreements .rcti-c04-register-page .rcti-agreement-dots-button {
  display: inline-flex;
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm, 8px);
  background: var(--surface-primary);
  color: var(--text-secondary);
  cursor: pointer;
}
.rcti-agreements .rcti-c04-register-page .rcti-agreement-dots-button:hover {
  border-color: var(--border-strong);
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-agreements .rcti-c04-register-page .rcti-agreement-dots-button svg {
  width: 18px;
  height: 18px;
}
.rcti-agreements
  .rcti-c04-register-page
  .rcti-design-register
  td:first-child
  strong {
  display: block;
  font-weight: var(--font-weight-medium);
  margin-bottom: var(--space-2);
}
.rcti-agreements
  .rcti-c04-register-page
  .rcti-design-register
  td:first-child
  button {
  min-height: 0;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-body-sm);
}
.rcti-agreements
  .rcti-c04-register-page
  .rcti-design-register
  td:last-child
  button {
  min-height: 0;
  white-space: nowrap;
  font-weight: var(--font-weight-medium);
}
.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--active {
  background: var(--interactive-soft);
  color: var(--interactive-default);
}
.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--awaiting {
  background: var(--warning-soft);
  color: var(--warning-text);
}
.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--proposed,
.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--ended,
.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--expired {
  background: var(--surface-tertiary);
  color: var(--text-secondary);
}
.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--suspended {
  background: var(--danger-soft);
  color: var(--danger-text);
}
.rcti-c04-pagination {
  padding: var(--space-4);
  border-top: 1px solid var(--border-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-c04-pagination > div {
  display: flex;
  gap: var(--space-2);
}
.rcti-agreements .rcti-c04-register-page .rcti-c04-pagination button {
  display: grid;
  place-items: center;
  min-height: 32px;
  width: 32px;
  padding: 0;
}
.rcti-c04-pagination svg {
  width: 16px;
  height: 16px;
}
.rcti-c04-footer-note {
  display: grid;
  gap: var(--space-3);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
@media (max-width: 1000px) {
  .rcti-agreements .rcti-c04-register-page .rcti-design-metrics {
    gap: var(--space-4);
  }
  .rcti-agreements
    .rcti-c04-register-page
    .rcti-design-metrics
    > button
    > span {
    font-size: var(--font-size-body-md);
  }
  .rcti-agreements .rcti-c04-register-page .rcti-design-filter {
    flex-wrap: wrap;
  }
  .rcti-agreements
    .rcti-c04-register-page
    .rcti-design-filter
    .rcti-c04-search {
    flex-basis: 100%;
    width: 100%;
  }
}
@media (max-width: 600px) {
  .rcti-agreements.rcti-designed
    .rcti-agreements__content.rcti-c04-register-page {
    padding: var(--space-5) var(--space-4);
  }
  .rcti-agreements .rcti-c04-register-page .rcti-design-metrics {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-c04-table-heading {
    flex-wrap: wrap;
    gap: var(--space-2);
  }
  .rcti-agreements
    .rcti-c04-register-page
    .rcti-design-filter
    > .quotation-figma-dropdown,
  .rcti-agreements
    .rcti-c04-register-page
    .rcti-design-filter
    > .quotation-figma-dropdown:nth-child(3) {
    flex: 0 0 calc((100% - var(--space-3, 12px)) / 2);
    width: calc((100% - var(--space-3, 12px)) / 2);
  }
}
.rcti-agreements.rcti-designed
  .rcti-c04-register-page
  .rcti-design-filter
  .rcti-c04-search
  > input {
  border: 0;
  border-radius: 0;
  padding: 0;
  min-width: 0;
  height: 38px;
  min-height: 0;
  background: transparent;
  box-shadow: none;
  outline: 0;
}
.rcti-agreements .rcti-c04-register-page .rcti-c04-search:focus-within {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.rcti-agreements .rcti-c04-register-page .rcti-c04-search .search-clear-button {
  width: 28px;
  height: 28px;
  min-height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-secondary);
}

.rcti-agreements
  .rcti-c04-register-page
  .rcti-design-register
  td:first-child
  > a {
  display: inline-block;
  font-size: var(--font-size-body-sm);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiAgreementsRegister.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;;EAEE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,MAAM;EACN,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,oCAAoC;EACpC,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;AACA;;;;;EAKE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;;;;EAIE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;AACA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,4CAA4C;EAC5C,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;;;EAKE,cAAc;EACd,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;;;;;EAKE,aAAa;EACb,uCAAuC;EACvC,mCAAmC;AACrC;AACA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;;EAGE,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE;IACE,mBAAmB;EACrB;EACA;;;;;IAKE,mCAAmC;EACrC;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,gBAAgB;IAChB,WAAW;EACb;AACF;AACA;EACE;;IAEE,sCAAsC;EACxC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;;;;;;;;IAQE,iDAAiD;IACjD,8CAA8C;EAChD;AACF;AACA;;;;;EAKE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;;;;EAKE,qBAAqB;EACrB,mCAAmC;AACrC","sourcesContent":["/* C04 agreements register. Keep every rule inside the content workspace. */\n.rcti-agreements.rcti-designed\n  .rcti-agreements__content.rcti-c04-register-page {\n  padding: var(--space-8);\n  gap: var(--space-6);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-breadcrumb {\n  display: none;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-heading {\n  margin-bottom: var(--space-1);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-metrics {\n  gap: var(--space-6);\n}\n.rcti-agreements\n  .rcti-c04-register-page\n  .rcti-design-metrics\n  > button.rcti-agreement-card {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  align-content: start;\n  justify-items: start;\n  height: auto;\n  min-height: 154px;\n  width: 100%;\n  gap: 0;\n  padding: var(--space-6);\n  text-align: left;\n  box-shadow: none;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-metrics > button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-metrics > button > span {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  color: var(--text-primary);\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.4;\n  width: 100%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-metrics svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  color: var(--interactive-default);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-metrics strong {\n  display: block;\n  margin-top: var(--space-6);\n  font-family: var(--font-family-mono);\n  font-size: var(--font-size-money-lg);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.2;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-metrics small {\n  display: block;\n  margin-top: var(--space-2);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: 1.4;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-tabs {\n  margin-bottom: calc(-1 * var(--space-3));\n}\n.rcti-agreements .rcti-c04-register-page .document-status-tabs > button:not(.is-active):not(:disabled) {\n  color: var(--text-primary);\n}\n.rcti-agreements .rcti-c04-register-page .document-status-tabs > button:not(.is-active):not(:disabled):hover {\n  color: var(--text-secondary);\n  background: transparent;\n  box-shadow: none;\n  filter: none;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-filter {\n  gap: var(--space-3);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-filter .rcti-c04-search {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  flex: 0 1 420px;\n  width: 420px;\n  height: 40px;\n  padding: 0 var(--space-3);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-c04-search > svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  color: var(--text-secondary);\n}\n.rcti-agreements\n  .rcti-agreements\n  .rcti-c04-register-page\n  .rcti-c04-search\n  input {\n  padding: 0;\n  min-height: 0;\n  height: 38px;\n  border: 0;\n  background: transparent;\n  border-radius: 0;\n  font: inherit;\n  box-shadow: none;\n}\n.rcti-agreements\n  .rcti-c04-register-page\n  .rcti-design-filter\n  > .quotation-figma-dropdown {\n  flex: 0 0 160px;\n  min-width: 0;\n  width: 160px;\n}\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-trigger {\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  border-width: 1px;\n  padding-inline: 12px;\n  border-radius: var(--radius-md, 10px);\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: 500 13px var(--font-family-primary);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-c04-clear-filters {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--border-subtle);\n  border-radius: 10px;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: 500 13px var(--font-family-primary);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-c04-clear-filters:hover {\n  background: var(--surface-secondary);\n  border-color: var(--border-default);\n  filter: none;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-c04-clear-filters:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu {\n  z-index: 1300 !important;\n  max-height: 240px;\n  overflow-y: auto;\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n}\n/* Menus portal into the register content, outside the filter toolbar. */\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu .quotation-figma-dropdown-option {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  height: auto;\n  min-height: 36px;\n  padding: 8px 10px;\n  font: 400 13px/20px var(--font-family-primary);\n  text-align: left;\n  white-space: normal;\n}\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu .quotation-figma-dropdown-option > span {\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-menu .quotation-figma-dropdown-option:is(:hover, :focus-visible, .is-selected):not(:disabled) {\n  background: var(--interactive-soft);\n  color: var(--interactive-default);\n  filter: none;\n}\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-trigger:hover {\n  border-color: var(--border-strong);\n}\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger,\n.rcti-agreements .rcti-c04-register-page .quotation-figma-dropdown-trigger:focus-visible {\n  border: 1px solid var(--interactive-default);\n  padding-inline: 12px;\n  box-shadow: none;\n}\n.rcti-c04-table-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  min-height: 52px;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c04-table-heading h2 {\n  font-size: var(--font-size-body-md);\n}\n.rcti-c04-table-heading span {\n  color: var(--text-secondary);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register table {\n  min-width: 1040px;\n  table-layout: fixed;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register th,\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td {\n  padding: 12px;\n  vertical-align: middle;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register th {\n  height: 44px;\n  font-size: var(--font-size-caption-md);\n  white-space: nowrap;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td {\n  font-size: var(--font-size-body-sm);\n  height: 68px;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(1) {\n  width: 19%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(2) {\n  width: 21%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(3) {\n  width: 8%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(4) {\n  width: 12%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(5) {\n  width: 12%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(6) {\n  width: 20%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register :is(th, td):nth-child(7) {\n  width: 8%;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(2) {\n  overflow-wrap: anywhere;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(3),\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(4),\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(5) {\n  white-space: nowrap;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td:nth-child(6) small {\n  margin-top: 3px;\n  line-height: 1.35;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-design-register th:last-child,\n.rcti-agreements .rcti-c04-register-page .rcti-design-register td:last-child {\n  text-align: right;\n  white-space: nowrap;\n}\n.rcti-agreement-register-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-dots-button {\n  display: inline-flex;\n  width: 32px;\n  min-width: 32px;\n  height: 32px;\n  min-height: 32px;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-sm, 8px);\n  background: var(--surface-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-dots-button:hover {\n  border-color: var(--border-strong);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-dots-button svg {\n  width: 18px;\n  height: 18px;\n}\n.rcti-agreements\n  .rcti-c04-register-page\n  .rcti-design-register\n  td:first-child\n  strong {\n  display: block;\n  font-weight: var(--font-weight-medium);\n  margin-bottom: var(--space-2);\n}\n.rcti-agreements\n  .rcti-c04-register-page\n  .rcti-design-register\n  td:first-child\n  button {\n  min-height: 0;\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreements\n  .rcti-c04-register-page\n  .rcti-design-register\n  td:last-child\n  button {\n  min-height: 0;\n  white-space: nowrap;\n  font-weight: var(--font-weight-medium);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--active {\n  background: var(--interactive-soft);\n  color: var(--interactive-default);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--awaiting {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--proposed,\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--ended,\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--expired {\n  background: var(--surface-tertiary);\n  color: var(--text-secondary);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-agreement-badge--suspended {\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n.rcti-c04-pagination {\n  padding: var(--space-4);\n  border-top: 1px solid var(--border-default);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c04-pagination > div {\n  display: flex;\n  gap: var(--space-2);\n}\n.rcti-agreements .rcti-c04-register-page .rcti-c04-pagination button {\n  display: grid;\n  place-items: center;\n  min-height: 32px;\n  width: 32px;\n  padding: 0;\n}\n.rcti-c04-pagination svg {\n  width: 16px;\n  height: 16px;\n}\n.rcti-c04-footer-note {\n  display: grid;\n  gap: var(--space-3);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n@media (max-width: 1000px) {\n  .rcti-agreements .rcti-c04-register-page .rcti-design-metrics {\n    gap: var(--space-4);\n  }\n  .rcti-agreements\n    .rcti-c04-register-page\n    .rcti-design-metrics\n    > button\n    > span {\n    font-size: var(--font-size-body-md);\n  }\n  .rcti-agreements .rcti-c04-register-page .rcti-design-filter {\n    flex-wrap: wrap;\n  }\n  .rcti-agreements\n    .rcti-c04-register-page\n    .rcti-design-filter\n    .rcti-c04-search {\n    flex-basis: 100%;\n    width: 100%;\n  }\n}\n@media (max-width: 600px) {\n  .rcti-agreements.rcti-designed\n    .rcti-agreements__content.rcti-c04-register-page {\n    padding: var(--space-5) var(--space-4);\n  }\n  .rcti-agreements .rcti-c04-register-page .rcti-design-metrics {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-c04-table-heading {\n    flex-wrap: wrap;\n    gap: var(--space-2);\n  }\n  .rcti-agreements\n    .rcti-c04-register-page\n    .rcti-design-filter\n    > .quotation-figma-dropdown,\n  .rcti-agreements\n    .rcti-c04-register-page\n    .rcti-design-filter\n    > .quotation-figma-dropdown:nth-child(3) {\n    flex: 0 0 calc((100% - var(--space-3, 12px)) / 2);\n    width: calc((100% - var(--space-3, 12px)) / 2);\n  }\n}\n.rcti-agreements.rcti-designed\n  .rcti-c04-register-page\n  .rcti-design-filter\n  .rcti-c04-search\n  > input {\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n  min-width: 0;\n  height: 38px;\n  min-height: 0;\n  background: transparent;\n  box-shadow: none;\n  outline: 0;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-c04-search:focus-within {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.rcti-agreements .rcti-c04-register-page .rcti-c04-search .search-clear-button {\n  width: 28px;\n  height: 28px;\n  min-height: 28px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary);\n}\n\n.rcti-agreements\n  .rcti-c04-register-page\n  .rcti-design-register\n  td:first-child\n  > a {\n  display: inline-block;\n  font-size: var(--font-size-body-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
